import FreezeLifecycleModule from "./FreezeLifecycleModule";
import reducer from "./redux/freezeLifecycleReducer";
import rootSaga from "./redux/freezeLifecycleSagas";

export default {
  Component: FreezeLifecycleModule,
  moduleName: "freezeLifecycle",
  saga: rootSaga(),
  reducer: reducer
};
